import { activityStepSchema } from "./activity-step.schema";
import type { ActivityStepInputs } from "./activity-step.schema";
import { billingStepSchema } from "./billing-step.schema";
import type { BillingStepInputs } from "./billing-step.schema";
import { studioStepSchema } from "./studio-step.schema";
import type { StudioStepInputs } from "./studio-step.schema";
import { pedagogyStepSchema } from "./pedagogy-step.schema";
import type { PedagogyStepInputs } from "./pedagogy-step.schema";
import { publicProfileStepSchema } from "./public-profile-step.schema";
import type { PublicProfileStepInputs } from "./public-profile-step.schema";

// ============================================================================
// Full Form Schema (Final Submission)
// - Combines all step schemas using concatenation
// - Used for final validation before submission
// ============================================================================

export const fullSchema = activityStepSchema
  .concat(pedagogyStepSchema)
  .concat(publicProfileStepSchema)
  .concat(billingStepSchema)
  .concat(studioStepSchema);

// ============================================================================
// Full Form Type
// ============================================================================

export type TeacherOnboardingFormInputs = ActivityStepInputs &
  PedagogyStepInputs &
  PublicProfileStepInputs &
  BillingStepInputs &
  StudioStepInputs;
